import md5 from "md5";
import { useNavigate } from "react-router-dom";

const SERVER_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getGravatarUrl = (email) => {
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?d=identicon`;
};

const Instructor = ({ mentor }) => {
  const navigate = useNavigate();

  if (!mentor) {
    return <p>No mentor information available</p>;
  }

  const getMentorImageUrl = (mentor) => {
    if (mentor.imageUrl) {
      // Ensure `/uploads/` is replaced correctly with `uploads/images/` if necessary
      const correctedImageUrl = mentor.imageUrl.replace(/^\/uploads/, "uploads/images");
  
      // Construct full URL by appending to the base server URL
      const finalImageUrl = `${SERVER_BASE_URL.replace(/\/$/, "")}/${correctedImageUrl}`;
      return finalImageUrl;
    } else {
      return getGravatarUrl(mentor.email || "");
    }
  };

  const handleSeeAllCourses = () => {
    navigate("/admin/courses");
  };

  const defaultAboutMe = `${mentor.firstName} ${mentor.lastName} is an expert in their field, bringing valuable experience and practical knowledge to their teaching.`;

  return (
    <div className="w-full rounded-xl bg-lightPrimary dark:bg-navy-700 px-6 py-6 border border-gray-200 dark:border-navy-600">
      <h4 className="text-xl font-bold text-navy-700 dark:text-white mb-4">
        About Instructor
      </h4>
      
      <div className="bg-white dark:bg-navy-800 rounded-lg p-4 mb-4 border border-gray-200 dark:border-navy-600">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-full border border-gray-200 dark:border-navy-600 overflow-hidden">
            <img
              className="h-full w-full rounded-full object-cover"
              src={getMentorImageUrl(mentor)}
              alt={`${mentor.firstName} ${mentor.lastName}`}
            />
          </div>
          <div>
            <h5 className="text-lg font-bold leading-6 text-navy-700 dark:text-white">
              {mentor.firstName} {mentor.lastName}
            </h5>
            <div className="flex items-center gap-2 mt-1">
              <span className="px-2 py-1 bg-gray-100 dark:bg-navy-600 text-gray-700 dark:text-gray-300 text-xs font-medium rounded-full">
                Mentor
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="bg-gray-50 dark:bg-navy-800 rounded-lg p-4 mb-6 border border-gray-200 dark:border-navy-600">
        <p className="leading-6 text-navy-700 dark:text-gray-300 text-sm">
          {mentor.aboutMe || defaultAboutMe}
        </p>
      </div>
      
      <button
        onClick={handleSeeAllCourses}
        className="w-full rounded-lg bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
      >
        See all courses
      </button>
    </div>
  );
};

export default Instructor;
